// extracted by mini-css-extract-plugin
module.exports = {"faq-section":"faqs_faq-section__hLG9z"};